
export class DeleteReason {
  reason: string;

  public constructor(init?: Partial<DeleteReason>) {
    Object.assign(this, init);
  }
}
